import React from 'react';
import App from './app/App';
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/lib/integration/react'
//import { BrowserRouter } from 'react-router-dom'
import { Router } from "react-router-dom";
import history from "./app/history";

import { persistor, store } from './app/store'
import ScrollToTop from './app/ScrollToTop'
import ErrorBoundary from './app/ErrorBoundary'
import Loading from './custom/Loading'

render(
  <Provider store={ store }>
    <PersistGate loading={ <Loading center /> } persistor={ persistor }>
      <Router history={ history } basename='/' >
        <ScrollToTop>
          <ErrorBoundary>
            <App/>
          </ErrorBoundary>
        </ScrollToTop>
      </Router>
    </PersistGate>
  </Provider>,
  document.getElementById('root')

); // END render



// WEBPACK FOOTER //
// ./src/index.js